import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { initialImageTest2State } from '../../image-store/image-store.service';
import { ImageState } from '../share/model';

import { fetchCommonValue } from '../share/utils';
import { Colormap, Colormaps } from '../share/colormap';

@Component({
  selector: 'app-colormap',
  templateUrl: './colormap.component.html',
  styleUrls: ['./colormap.component.css'],
})
export class ColormapComponent implements OnInit, OnDestroy {
  private colormapSubject = new BehaviorSubject<Colormap | undefined>(
    Colormaps.GRAY,
  );
  readonly colormap$ = this.colormapSubject.asObservable();
  readonly colormapName$ = this.colormap$.pipe(
    map((c) => (c === undefined ? undefined : c.name)),
  );

  @Input()
  set colormap(c: Colormap | undefined) {
    this.colormapSubject.next(c);
  }
  get colormap(): Colormap | undefined {
    return this.colormapSubject.value;
  }
  @Output()
  colormapChange = new EventEmitter<Colormap>();
  @Input()
  set related(images: ImageState[]) {
    this.setInputToDefault(images);
  }

  constructor() {
    this.colormap$
      .pipe(filter((c): c is Colormap => c !== undefined))
      .subscribe((c) => this.colormapChange.emit(c), (e) => console.error(e));
  }

  ngOnDestroy(): void {
    this.colormapSubject.complete();
  }

  ngOnInit() {}

  onChangeSelect(name: string | undefined) {
    switch (name) {
      case 'gray':
        this.colormap = Colormaps.GRAY;
        break;
      case 'hot':
        this.colormap = Colormaps.HOT;
        break;
      default:
        this.colormap = undefined;
    }
  }

  setInputToDefault(images: ImageState[]) {
    if (images.length === 0) {
      return;
    }
    this.colormap = fetchCommonValue(images, (image) => image.colormap);
  }
}
